import React from "react"
import { Group } from "@mantine/core"

import { Button, Modal, Icon } from "@/components"
import { useStyles } from "@/components/TopNavigation/components/AdvancedSearchTipsModal/AdvancedSearchTipsModal.styles"
// @ts-expect-error
import { BOOLEAN_SEARCH_HELPCENTER_URL } from "app/static/frontend/search-new/constants"

export const AdvancedSearchTipsModal = ({
    isOpen,
    searchTips,
}: {
    isOpen: boolean
    searchTips: {
        readonly open: () => void
        readonly close: () => void
        readonly toggle: () => void
    }
}) => {
    const { classes, cx } = useStyles()

    const Row = ({ type, description, example }) => (
        <div className={classes.dataRow}>
            <div className={cx(classes.typeData, classes.cell)}>{type}</div>
            <div className={cx(classes.descriptionCell, classes.cell)}>{description}</div>
            <div className={cx(classes.descriptionCell, classes.cell)}>{example}</div>
        </div>
    )

    return (
        <Modal.Root onClose={searchTips.close} opened={isOpen} size="auto" centered radius="md">
            <Modal.Overlay />
            <Modal.Content className={classes.container}>
                <Modal.Header className={classes.header}>
                    <Modal.Title className={classes.title}>Advanced Search Tips</Modal.Title>
                    <Modal.CloseButton onClick={searchTips.close} />
                </Modal.Header>

                <Modal.Body className={classes.body}>
                    <div className={classes.headerRow}>
                        <div className={cx(classes.typeCell, classes.cell)}>Type</div>
                        <div className={cx(classes.descriptionCell, classes.cell)}>Description</div>
                        <div className={cx(classes.descriptionCell, classes.cell)}>Example</div>
                    </div>
                    <div>
                        <Row
                            type="Quote"
                            description={`"expression" - A word/phrase surrounded by quotation marks shows items containing only that
                            exact word or phrase and disables natural language processing. Quotations can go around any
                            individual item in your query to make that portion of the search exact.`}
                            example={`"Securities" - Search for exact mentions of the word securities, without natural language
                            processing showing similar words.`}
                        />
                        <Row
                            type="AND"
                            description="expression AND expression - Shows results only for items that contain both expressions."
                            example="trade AND investments - Search for items mentioning both trade and investments."
                        />
                        <Row
                            type="OR"
                            description="expression OR expression - Shows results for any items containing either the first expression or the second expression (or both)."
                            example="expression OR expression - Shows results for any items containing either the first expression or the second expression (or both)."
                        />
                        <Row
                            type="AND NOT"
                            description="expression AND NOT expression - Shows results for items which contain the first expression but not the second expression."
                            example="expression AND NOT expression - Shows results for items which contain the first expression but not the second expression."
                        />
                        <Row
                            type="Parentheses"
                            description={
                                "(expression OR expression) AND expression - Controls the precedence in which boolean operators take effect. " +
                                "You can combine parentheses with any other operator but parenthetical expressions must be combined with AND, OR, or AND NOT operators."
                            }
                            example={`"("e-cigarette" OR "vape") AND regulations - A search for items that mention either e-cigarette or vape and that also mention regulations."`}
                        />
                    </div>
                </Modal.Body>

                <Group className={classes.buttonsGroup}>
                    <Button onClick={searchTips.close}>Got it!</Button>
                    <Button
                        className={classes.moreHelpButton}
                        variant="outline"
                        component="a"
                        href={BOOLEAN_SEARCH_HELPCENTER_URL}
                        rightIcon={<Icon icon="external-link" />}
                        target="_blank"
                    >
                        I need more help
                    </Button>
                </Group>
            </Modal.Content>
        </Modal.Root>
    )
}
